import React, { useState, useEffect } from "react";
import { EAData } from "../../../network/api/EAData";
import Toast from "../../../../../components/Toast";
import ButtonLoader from "../../../../../components/ButtonLoader";
import FileUpload from "../../../components/FileUpload";

const colorSchemes = [
  "Default", "Pink", "Green", "Blue_Light", "Red", "Purple", "Orange", "Yellow", "Black",
  "Red_Inverse", "Purple_Inverse", "Pink_Inverse", "Yellow_Inverse", "Orange_Inverse",
  "Green_Inverse", "Blue_Light_Inverse", "Black_Inverse"
];

export default function EditEAForm({ method = "PUT", expert, setExpert, ownerId = null }) {

  const [formData, setFormData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [toastConfig, setToastConfig] = useState({ visible: false, message: "", type: "primary" });

  const [isFormEdited, setIsFormEdited] = useState(false);
  const [fileData, setFileData] = useState(null);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    setIsFormEdited(true);
  };

  const handleCustomizationChange = (e) => {
    const { name, value } = e.target;
    
    setFormData((prev) => ({ ...prev, metadata: { ...prev.metadata, app_theme: { ...prev.metadata.app_theme, [name]: value } } }));
    
    setIsFormEdited(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      setIsFormEdited(false);
      const response = await EAData({ method: method, id: expert?.id, formData });
      if (response.status === "success") {
        setToastConfig({ visible: true, message: "EA updated successfully!", type: "success" });

        const updateExpert = {
          ...expert,
          name: expert?.name || null,
          image_url: formData?.image_url || null,
          description: formData?.description || null,
          color_scheme: formData?.color_scheme || null,
          social_url: formData?.social_url || null,
          metadata: {
            app_theme: {
              size: formData?.metadata?.app_theme?.size || "min",
              action_buttons: formData?.metadata?.app_theme?.action_buttons || "classic",
              bot_list: formData?.metadata?.app_theme?.bot_list || "new",
              bottom_menu: formData?.metadata?.app_theme?.bottom_menu || "classic"
            }
          }
        };
        setExpert(updateExpert);
      } else {
        setToastConfig({ visible: true, message: response.message, type: "danger" });
      }
    } catch (err) {
      setToastConfig({ visible: true, message: "Update failed", type: "danger" });
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    setFormData(
      {
        id: expert?.id,
        owner: ownerId,
        name: expert?.name || null,
        image_url: expert?.image_url || null,
        description: expert?.description || null,
        color_scheme: expert?.color_scheme || null,
        social_url: expert?.social_url || null,
        metadata: {
          app_theme: {
            size: expert?.metadata?.app_theme?.size || "min",
            action_buttons: expert?.metadata?.app_theme?.action_buttons || "classic",
            bot_list: expert?.metadata?.app_theme?.bot_list || "new",
            bottom_menu: expert?.metadata?.app_theme?.bottom_menu || "classic"
          }
        }
      }
    )
  }, [expert, ownerId, fileData]);

  useEffect(() => {
    if (fileData) {
      setIsFormEdited(true);
      setFormData((prev) => ({ ...prev, image_url: fileData?.file_url }));
    }
  }, [fileData]);

  return (
    <div className="container">
      <Toast message={toastConfig.message} type={toastConfig.type} visible={toastConfig.visible} setVisible={(v) => setToastConfig({ ...toastConfig, visible: v })} />

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">EA Name</label>
          <input type="text" name="name" className="form-control" value={formData?.name || ""} onChange={method === "POST" ? handleChange : () => { }} placeholder="Full EA Name including version number" disabled={method !== "POST"} />
        </div>
        <div className="mb-3">
          <label className="form-label">Description</label>
          <textarea name="description" className="form-control" rows="3" value={formData?.description || ""} onChange={handleChange} placeholder="A short dexription, like our ea will get you 100% win rate etc, or watever."></textarea>
        </div>
        <div className="mb-3">
          <label className="form-label">Social URL</label>
          <input type="url" name="social_url" className="form-control" value={formData?.social_url || ""} onChange={handleChange} placeholder="https://wa.me/27712345678" />
        </div>


        <div className="mb-3 ">
          <label className="form-label ">App Customization</label>
          <div className="row custom-card card-body">
            <div className="mb-3">
              <label className="form-label">Color Scheme</label>
              <select name="color_scheme" className="form-select" id="colorSelector" value={formData?.color_scheme || ""} onChange={handleChange}>
                {colorSchemes.map((scheme, idx) => (
                  <option key={idx} value={scheme}>
                    {scheme.replace(/_/g, " ")}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-6 mb-2">
              <label className="form-label">Size</label>
              <select name="size" className="form-select" value={formData?.metadata?.app_theme?.size || ""} onChange={handleCustomizationChange}>
                <option value="min">Classic</option>
                <option value="med">Medium</option>
                <option value="max">Maximum</option>
              </select>
            </div>
            <div className="col-md-6 mb-2">
              <label className="form-label">Action Buttons</label>
              <select name="action_buttons" className="form-select" value={formData?.metadata?.app_theme?.action_buttons || ""} onChange={handleCustomizationChange}>
                <option value="classic">Classic</option>
                <option value="new">New</option>
              </select>
            </div>
            <div className="col-md-6 mb-2">
              <label className="form-label">Bot List</label>
              <select name="bot_list" className="form-select" value={formData?.metadata?.app_theme?.bot_list || ""} onChange={handleCustomizationChange}>
                <option value="modern">New</option>
              </select>
            </div>
            <div className="col-md-6 mb-2">
              <label className="form-label">Bottom Menu</label>
              <select name="bottom_menu" className="form-select" value={formData?.metadata?.app_theme?.bottom_menu || ""} onChange={handleCustomizationChange}>
                <option value="classic">Classic</option>
                <option value="new">New</option>
              </select>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Image URL</label>
          <input type="text" name="image_url" className="form-control" value={formData?.image_url || ""} onChange={handleChange} placeholder="https://shomewhere.com/image.png" />
        </div>
        <div className="mb-3">
          <label className="form-label">Upload Image</label>
          <FileUpload owner={ownerId} setFileData={setFileData} description={"Expert Advisor Image"} />
        </div>
        <button className="btn btn-primary btn-block" type="submit" disabled={(isLoading || !isFormEdited)}>{isLoading ? <ButtonLoader /> : (method === "POST" ? "Create" : "Save")}</button>

      </form>

    </div>
  );
}
